import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ChevronRight } from 'lucide-react';
import { formatDate } from '../../lib/utils';
import LeadForm from '../shared/LeadForm';

export const BlogPreview = ({ loading, recentPosts }) => (
  <section className="py-10 md:py-14 lg:py-16 bg-slate-50" data-testid="blog-preview-section">
    <div className="container-apex">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12 gap-4">
        <div>
          <p className="text-[#007f73] font-medium mb-3 text-sm uppercase tracking-wider">Conteúdos</p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900">
            Artigos e insights para o setor médico
          </h2>
        </div>
        <Button asChild variant="outline" className="btn-secondary rounded-md">
          <Link to="/blog">
            Ver todos os artigos
            <ChevronRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {loading ? (
          Array(3).fill(0).map((_, i) => (
            <div key={i} className="bg-white rounded-xl overflow-hidden">
              <div className="skeleton h-48 w-full" />
              <div className="p-6">
                <div className="skeleton h-4 w-24 mb-3" />
                <div className="skeleton h-6 w-full mb-2" />
                <div className="skeleton h-6 w-3/4 mb-4" />
                <div className="skeleton h-4 w-full" />
              </div>
            </div>
          ))
        ) : recentPosts.length > 0 ? (
          recentPosts.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              className="group bg-white rounded-xl overflow-hidden border border-slate-100 hover:shadow-md transition-all duration-300"
              data-testid={`blog-card-${post.slug}`}
            >
              <div className="blog-card-image">
                <img
                  src={post.featured_image || ''}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  style={{ objectPosition: post.featured_image_position || 'center' }}
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <span className="category-badge mb-3">{post.category_name}</span>
                <h3 className="font-heading font-semibold text-lg text-slate-900 mb-2 line-clamp-2 group-hover:text-primary transition-colors">
                  {post.title}
                </h3>
                <p className="text-slate-600 text-sm line-clamp-2 mb-4">{post.excerpt}</p>
                <div className="flex items-center justify-between text-sm text-slate-500">
                  <span>{formatDate(post.published_at)}</span>
                  <span>{post.reading_time} min de leitura</span>
                </div>
              </div>
            </Link>
          ))
        ) : (
          <div className="col-span-3 text-center py-12">
            <p className="text-slate-500">Nenhum artigo publicado ainda.</p>
          </div>
        )}
      </div>
    </div>
  </section>
);

export const LeadSection = () => (
  <section className="py-10 md:py-14 lg:py-16 bg-white border-t border-slate-100" data-testid="lead-section">
    <div className="container-apex">
      <div className="max-w-4xl mx-auto">
        <div className="bg-slate-50 rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="font-heading text-2xl font-bold text-slate-900 mb-3">
                Receba conteúdos estratégicos
              </h3>
              <p className="text-slate-600">
                Cadastre-se para receber artigos, dicas e atualizações sobre gestão de clínicas e consultórios médicos.
              </p>
            </div>
            <div>
              <LeadForm variant="compact" source="homepage-newsletter" showClinicField={false} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
